import type { Fields } from "@smartsuite/smartsuite-client";
import { ValueDescription_T } from "@smartsuite/automation-engine-api";

export const ssTypes: Fields[] = [
  "recordtitlefield",
  "textfield",
  "textnestedfield",
  "emailfield",
  "addressfield",
  "textareafield",
  "richtextareafield",
  "linkfield",
  "phonefield",
  "recordidfield",
  "colorpickerfield",
  "datefield",
  "daterangefield",
  "durationfield",
  "duedatefield",
  "timetrackingfield",
  "multipleselectfield",
  "singleselectfield",
  "statusfield",
  "tagsfield",
  "yesnofield",
  "ipaddressfield",
  "linkedrecordfield",
  "userfield",
  "subitemsfield",
  "filefield",
  "signaturefield",
  "unknownfield",
  "numberfield",
  "currencyfield",
  "percentfield",
  "percentcompletefield",
  "autonumberfield",
  "countfield",
  "votefield",
  "numbersliderfield",
  "commentscountfield",
  "ratingfield",
  "availabilitystatusfield",
  "socialnetworkfield",
  "timefield",
  "firstcreatedfield",
  "lastupdatedfield",
  "rollupfield",
  "lookupfield",
  "fullnamefield",
  "hidden_textfield",
  "checklistfield",
  // "formulafield",
  "smartdocfield",
  "dependencyfield",
  "teamfield",
];

export const generalTypes: ValueDescription_T[] = [
  ValueDescription_T.UNKNOWN,
  ValueDescription_T.ANY,
  ValueDescription_T.STRING,
  ValueDescription_T.FILE_URL,
  ValueDescription_T.BOOL,
  ValueDescription_T.NUMBER,
  ValueDescription_T.DATE,
  ValueDescription_T.OUTPUT_LIST,
  ValueDescription_T.EMAIL,
  ValueDescription_T.SELECT,
  ValueDescription_T.MEMBER,
  ValueDescription_T.LINK,
  ValueDescription_T.PHONE,
  ValueDescription_T.FILE,
  ValueDescription_T.SCHEDULE,
  ValueDescription_T.SMARTDOC,
  ValueDescription_T.CHECKLIST,
  ValueDescription_T.STATUS,
  ValueDescription_T.TAG,
  ValueDescription_T.LIST,
];
